import { Component, Injector } from "@angular/core";
import { OrgsComponent } from "../orgs.component";
import { InventoryMockService } from "../../inventory/services/inventory-mock.service";
import { KeyBalances, OrgInventoryMeta } from "../../inventory/models/inventory.model";

@Component({
  selector: "app-roster-table-view",
  templateUrl: "./roster-table-view.component.html",
  styleUrls: ["./roster-table-view.component.scss"],
})
export class RosterTableViewComponent {
  injectedCompo;

  constructor(private injector: Injector, public inventory: InventoryMockService) {
    this.injectedCompo = this.injector.get(OrgsComponent);
  }

  trackByOrg(index: number, record: any): any { return record?.id ?? index; }

  bal(record: any): KeyBalances { return this.inventory.balances(record?.id ?? '', record?.name ?? ''); }
  meta(record: any): OrgInventoryMeta { return this.inventory.meta(record?.id ?? '', record?.name ?? ''); }

  // Buying type and team reports are no longer columns here — they live on the inventory detail.
  invSortKey: '' | 'members' | 'individual' | 'group' | 'results' | 'pricing' | 'buyer' = '';
  invSortDir: 'asc' | 'desc' = 'asc';

  sortInv(key: 'members' | 'individual' | 'group' | 'results' | 'pricing' | 'buyer'): void {
    if (this.invSortKey === key) { this.invSortDir = this.invSortDir === 'asc' ? 'desc' : 'asc'; }
    else { this.invSortKey = key; this.invSortDir = 'asc'; }
    const dir = this.invSortDir === 'asc' ? 1 : -1;
    const val = (r: any): string | number => {
      const b = this.bal(r); const m = this.meta(r);
      switch (key) {
        case 'members': return r.members_count ?? 0;   // on the record, not the mock inventory
        case 'individual': case 'group': return b[key];
        case 'results': return m.results;
        default: return String(m[key]).toLowerCase();
      }
    };
    (this.injectedCompo.organizations || []).sort((a: any, x: any) => {
      const av = val(a), xv = val(x); return av < xv ? -dir : av > xv ? dir : 0;
    });
  }
  invSortIcon(key: string): string { return this.invSortKey !== key ? 'fa-sort' : (this.invSortDir === 'asc' ? 'fa-sort-asc' : 'fa-sort-desc'); }
}
